import Vue from 'vue'
import Router from 'vue-router'
import ChangeEmail from '../views/ChangeEmail.vue'
import ChangeOptIn from '../views/ChangeOptIn.vue'
import ChangePassword from '../views/ChangePassword.vue'
import CompleteChangeEmail from '../views/CompleteChangeEmail.vue'
import CompleteChangePassword from '../views/CompleteChangePassword.vue'
import CompleteForgotPassword from '../views/CompleteForgotPassword.vue'
import CompleteSignup from '../views/CompleteSignup.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import Home from '../views/Home.vue'
import Signin from '../views/Signin.vue'
import Signup from '../views/Signup.vue'
import VerifyChangeEmail from '../views/VerifyChangeEmail.vue'
import VerifyForgotPassword from '../views/VerifyForgotPassword.vue'
import VerifySignup from '../views/VerifySignup.vue'

import MainFooter from '../layout/MainFooter.vue'
import MainNavbar from '../layout/MainNavbar.vue'
import store from '../store/index.js'

// Amplify読み込み
import * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'

import MaintenanceScreen from '@/views/MaintenanceScreen.vue';
import { MaintenanceService } from '@/services/MaintenanceService';

import DeleteAccount from '../views/DeleteAccount.vue'
import CompleteDeleteAccount from '../views/CompleteDeleteAccount.vue'

Vue.use(Router)
Vue.use(AmplifyPlugin, AmplifyModules)

const DEFAULT_TITLE = ' | 英辞郎 on the WEB ユーザー登録センター'
let user

function getUser() {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
    .then((data) => {
      if (data && data.signInUserSession) {
        store.commit('setUser', data)
        return data
      }
    })
    .catch(() => {
      store.commit('setUser', null)
      return null
    })
}

// ルーティング設定
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/signin',
      name: 'signin',
      components: { default: Signin, header: MainNavbar, footer: MainFooter },
      meta: { title: 'ログイン' },
    },
    {
      path: '/signup',
      name: 'signup',
      components: { default: Signup, header: MainNavbar, footer: MainFooter },
      meta: { title: '新規登録' },
    },
    {
      path: '/verify-signup',
      name: 'verifySignup',
      components: { default: VerifySignup, header: MainNavbar, footer: MainFooter },
      meta: { title: '新規登録(確認)' },
    },
    {
      path: '/complete-signup',
      name: 'completeSignup',
      components: { default: CompleteSignup, header: MainNavbar, footer: MainFooter },
      meta: { title: '新規登録(完了)' },
    },
    {
      path: '/forgot-password',
      name: 'forgotPassword',
      components: { default: ForgotPassword, header: MainNavbar, footer: MainFooter },
      meta: { title: 'パスワード再設定' },
    },
    {
      path: '/verify-forgot-password',
      name: 'verifyForgotPassword',
      components: { default: VerifyForgotPassword, header: MainNavbar, footer: MainFooter },
      meta: { title: 'パスワード再設定(確認)' },
    },
    {
      path: '/',
      name: 'home',
      components: { default: Home, header: MainNavbar, footer: MainFooter },
      meta: { title: 'Top' },
    },
    {
      path: '/change-password',
      name: 'changePassword',
      components: { default: ChangePassword, header: MainNavbar, footer: MainFooter },
      meta: { requiresAuth: true, title: 'パスワード変更' },
    },
    {
      path: '/change-email',
      name: 'changeEmail',
      components: { default: ChangeEmail, header: MainNavbar, footer: MainFooter },
      meta: { requiresAuth: true, title: 'メールアドレス変更' },
    },
    {
      path: '/verify-change-email',
      name: 'verifyChangeEmail',
      components: { default: VerifyChangeEmail, header: MainNavbar, footer: MainFooter },
      meta: { requiresAuth: true, title: 'メールアドレス変更(確認)' },
    },
    {
      path: '/change-opt-in',
      name: 'changeOptIn',
      components: { default: ChangeOptIn, header: MainNavbar, footer: MainFooter },
      meta: { requiresAuth: true, title: 'メールマガジン等の配信設定' },
    },
    {
      path: '/complete-change-email',
      name: 'completeChangeEmail',
      components: { default: CompleteChangeEmail, header: MainNavbar, footer: MainFooter },
      meta: { title: 'メールアドレス変更(完了)' },
    },
    {
      path: '/complete-change-password',
      name: 'completeChangePassword',
      components: { default: CompleteChangePassword, header: MainNavbar, footer: MainFooter },
      meta: { title: 'パスワード変更(完了)' },
    },
    {
      path: '/complete-delete-account',
      name: 'completeDeleteAccount',
      components: { default: CompleteDeleteAccount, header: MainNavbar, footer: MainFooter },
      meta: { title: 'アカウント削除(完了)'},
    },
    {
      path: '/complete-forgot-password',
      name: 'completeForgotPassword',
      components: { default: CompleteForgotPassword, header: MainNavbar, footer: MainFooter },
      meta: { title: 'パスワード再設定(完了)' },
    },
    {
      path: '/delete-account',
      name: 'deleteAccount',
      components: { default: DeleteAccount, header: MainNavbar, footer: MainFooter },
      meta: { requiresAuth: true, title: 'アカウント削除'},
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: MaintenanceScreen,
      meta: { title: 'メンテナンス中' },
    },
  ],
})

// リダイレクト設定
router.beforeResolve(async (to, from, next) => {
  if (to.name === 'completeSignup' && from.name !== 'verifySignup') {
    return next({ name: 'home' })
  }
  if (to.name === 'verifySignup' && from.name !== 'signup') {
    return next({ name: 'home' })
  }
  if (to.name === 'verifySignup') {
    store.commit('setFromVerifySignup', true)
    store.commit('setFromSignup', false)
  }
  if (to.name === 'signup') {
    const user = await getUser()
    if (user) {
      return next({ name: 'home' })
    } else {
      store.commit('setFromSignup', true)
    }
  }

  if (to.name === 'verifyForgotPassword' && from.name !== 'forgotPassword') {
    return next({ name: 'home' })
  }
  if (to.name === 'completeForgotPassword' && from.name !== 'verifyForgotPassword') {
    return next({ name: 'home' })
  }
  if (to.name === 'completeChangePassword' && from.name !== 'changePassword') {
    return next({ name: 'home' })
  }
  if (to.name === 'verifyChangeEmail' && from.name !== 'changeEmail') {
    return next({ name: 'home' })
  }
  if (to.name === 'completeChangeEmail' && from.name !== 'verifyChangeEmail') {
    return next({ name: 'home' })
  }
  if (to.name === 'completeDeleteAccount' && from.name !== 'deleteAccount') {
    return next({ name: 'home' })
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    user = await getUser()
    if (!user) {
      store.commit('setLoginTransitionPagePath', to.path)
      return next({
        path: '/signin',
        query: { force: true },
      })
    }
    return next()
  }
  return next()
})

// Title設定
router.afterEach((to, from) => {
  document.title = to.meta.title + DEFAULT_TITLE
})

// メンテナンス・モードを管理するミドルウェア
router.beforeEach(async (to, from, next) => {
  const isUnderMaintenance = await MaintenanceService.isUnderMaintenance();

  // '/maintenance'へのアクセスを許可し、他のページをリダイレクトする。
  if (isUnderMaintenance && to.name !== 'maintenance') {
    next({ name: 'maintenance' });
  } else if (!isUnderMaintenance && to.name == 'maintenance') {
    next({ name: 'home' });
  } else {
    next();
  }
});

export default router
